import { E_ROUTE_DATA_ANALYSIS } from './route.types';
export default [
    {
        name: E_ROUTE_DATA_ANALYSIS.USER_ANALYSIS,
        path: '/data-analysis/user-analysis',
        component: () => import(/* webpackChunkName: "dataAnalysis" */ '../../views/data-analysis/UserAnalysis/UserAnalysis.vue'),
        meta: {
            breadcrumb: [
            // {
            //     text: 'backoffice.nav.DataAnalysis',
            // },
            // {
            //     text: 'backoffice.nav.UserAnalysis',
            //     active: true,
            // },
            ],
        },
        permission: 'UserAnalysis',
    }
];
